import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../../constants/fetchStatuses';
import { ReducerState } from '../../../store.types';

export const onboardingEmployeeSelector = ({ onboardingEmployee }: ReducerState) => onboardingEmployee;

export const onboardingEmployeesLoadingSelector = createSelector(
  onboardingEmployeeSelector,
  ({ fetchOnboardingEmployeesStatus }) => fetchOnboardingEmployeesStatus === fetchStatuses.pending,
);
